import * as React from "react"
const SvgHeading6 = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 17.857a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-8q0-.424.288-.712A.97.97 0 0 1 4 7.857a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v3h4v-3a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v8a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-3H5v3a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287m11 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 15.857v-6q0-.825.588-1.412A1.93 1.93 0 0 1 15 7.857h5q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287h-5v2h4q.824 0 1.413.588.587.587.587 1.412v2a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-4v2h4v-2z" />
  </svg>
)
export default SvgHeading6
